import { combineReducers } from 'redux';

import flashMessages from './reducers/flashMessages';
import search from './reducers/search';

const rootReducer = combineReducers({
  flashMessages,
  search
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/codes/reducer.js